(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  const layoutTop = element => {
    let top = 0;
    for (let node = element; node; node = node.offsetParent) top += node.offsetTop;
    return top;
  };
  const align = () => {
    pending = false;
    document.querySelectorAll('.product-grid').forEach(grid => {
      const rows = new Map();
      const entries = [...grid.querySelectorAll('.product-card-wrapper')].map(card => {
        const heading = card.querySelector(':scope > .card > .card__content > .card__information > .card__heading');
        const image = card.querySelector(':scope > .card > .card__inner');
        if (!heading || !image || !card.offsetWidth) return null;
        return { heading, image };
      }).filter(Boolean);
      entries.forEach(({ heading }) => {
        heading.style.removeProperty('--sienna-heading-offset');
        heading.style.removeProperty('--sienna-heading-height');
      });
      entries.forEach(entry => {
        entry.top = layoutTop(entry.heading);
        entry.height = entry.heading.offsetHeight;
        const key = Math.round(layoutTop(entry.image) / 5);
        if (!rows.has(key)) rows.set(key, []);
        rows.get(key).push(entry);
      });
      const updates = [];
      rows.forEach(row => {
        const positions = row.map(entry => entry.top);
        const top = Math.max(...positions);
        const height = Math.max(...row.map(entry => entry.height));
        row.forEach((entry, index) => {
          updates.push({ heading: entry.heading, offset: Math.max(0, top - positions[index]), height });
        });
      });
      updates.forEach(({ heading, offset, height }) => {
        heading.style.setProperty('--sienna-heading-offset', offset + 'px');
        heading.style.setProperty('--sienna-heading-height', height + 'px');
      });
    });
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(align); }
  };
  const start = () => {
    schedule();
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest('.product-grid')) return true;
        return [...record.addedNodes, ...record.removedNodes].some(node =>
          node.nodeType === 1 && (node.matches('.product-grid') || node.querySelector('.product-grid'))
        );
      })) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    let resizeTimer;
    window.addEventListener('resize', () => { clearTimeout(resizeTimer); resizeTimer = setTimeout(schedule, 120); });
    document.addEventListener('load', event => { if (event.target.closest?.('.product-grid')) schedule(); }, true);
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sienna-compact-description"] && !Shopify.designMode) return;
  try {
    (() => {
  const text = node => node.textContent.replace(/\s+/g, ' ').trim();
  const shorten = (value, limit) => {
    if (value.split(/\s+/).length <= limit) return value;
    const sentences = value.match(/[^.!?]+[.!?]+(?:\s|$)|[^.!?]+$/g) || [value];
    let result = '';
    for (const sentence of sentences) {
      if ((result + sentence).trim().split(/\s+/).length > limit) break;
      result += sentence;
    }
    return result.trim() || value.split(/\s+/).slice(0, limit).join(' ') + '…';
  };
  function compact(scope = document) {
    const label = document.querySelector('[data-sienna-description-label]')?.content.textContent.trim();
    if (!label) return;
    scope.querySelectorAll('.product__description:not([data-sienna-compact])').forEach(root => {
      root.dataset.siennaCompact = 'true';
      root.classList.add('sienna-description-compact');
      const heading = root.querySelector('.sienna-description-heading');
      const guides = [...root.querySelectorAll('.sienna-size-guide')];
      const source = root.cloneNode(true);
      source.querySelectorAll('.sienna-description-heading,.sienna-size-guide').forEach(node => node.remove());
      const fullText = text(source);
      if (fullText.split(/\s+/).length <= 70) return;
      const paragraphs = [...source.querySelectorAll('p')].filter(p => !p.closest('li') && text(p));
      const intro = paragraphs.find(p => text(p).split(/\s+/).length >= 12 && !p.querySelector('strong,b'))
        || paragraphs.find(p => text(p).split(/\s+/).length >= 12);
      const candidates = [...source.querySelectorAll('li')].filter(node => text(node));
      if (!candidates.length) candidates.push(...paragraphs.filter(p => p !== intro && text(p).split(/\s+/).length >= 4));
      const summary = document.createElement('div');
      summary.className = 'sienna-description-summary';
      const seen = new Set();
      if (intro) {
        const lead = document.createElement('p');
        lead.textContent = shorten(text(intro), 32);
        summary.append(lead);
        seen.add(text(intro).toLowerCase());
      }
      const list = document.createElement('ul');
      for (const candidate of candidates) {
        const value = text(candidate);
        if (seen.has(value.toLowerCase()) || list.children.length >= 4) continue;
        seen.add(value.toLowerCase());
        const item = document.createElement('li');
        if (value.split(/\s+/).length <= 14) {
          item.innerHTML = candidate.innerHTML;
          item.querySelectorAll('[style]').forEach(node => node.removeAttribute('style'));
        } else item.textContent = shorten(value, 14);
        list.append(item);
      }
      if (list.children.length) summary.append(list);
      if (!summary.children.length) {
        const lead = document.createElement('p');
        lead.textContent = shorten(fullText, 48);
        summary.append(lead);
      }
      const details = document.createElement('details');
      details.className = 'sienna-description-details';
      const toggle = document.createElement('summary');
      toggle.textContent = label;
      const full = document.createElement('div');
      full.className = 'sienna-description-full';
      full.append(...source.childNodes);
      details.append(toggle, full);
      root.replaceChildren(...(heading ? [heading] : []), summary, details, ...guides);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => compact(), { once: true });
  else compact();
  document.addEventListener('shopify:section:load', event => compact(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sienna-description-size-guides"] && !Shopify.designMode) return;
  try {
    (() => {
  const clean = value => value.trim().replace(/:\s*$/, '');
  function format(scope = document) {
    scope.querySelectorAll('.sienna-size-guide table:not([data-sienna-horizontal])').forEach(table => {
      const rows = [...table.rows];
      if (rows.length < 2 || rows.some(row => [...row.cells].some(cell => cell.colSpan > 1 || cell.rowSpan > 1))) return;
      const header = [...rows[0].cells];
      if (!/(\bsize\b|\bsizes\b|talla|tamaño|taille|gr[oö]ße|tamanho|^(au|aus|eu|uk|us)$)/i.test(clean(header[0]?.textContent || ''))) return;
      const data = rows.slice(1).map(row => [...row.cells]);
      if (data.some(row => row.length !== header.length)) return;
      const sizes = data.map(row => row[0].textContent.trim());
      const labels = [];
      const values = data.map(cells => {
        const map = new Map();
        if (header.length === 2 && cells[1].querySelector('strong')) {
          for (const part of cells[1].innerHTML.split(/<br\s*\/?\s*>/i)) {
            const fragment = document.createElement('template');
            fragment.innerHTML = part;
            const label = fragment.content.querySelector('strong');
            if (!label) return null;
            const name = clean(label.textContent);
            label.remove();
            if (!name || map.has(name)) return null;
            map.set(name, fragment.content.textContent.trim());
            if (!labels.includes(name)) labels.push(name);
          }
        } else {
          header.slice(1).forEach((cell, index) => {
            const name = clean(cell.textContent);
            map.set(name, cells[index + 1].textContent.trim());
            if (!labels.includes(name)) labels.push(name);
          });
        }
        return map;
      });
      if (!labels.length || values.some(value => !value)) return;
      const head = document.createElement('thead');
      const headRow = head.insertRow();
      [header[0].textContent.trim(), ...sizes].forEach(text => {
        const cell = document.createElement('th');
        cell.scope = 'col';
        cell.textContent = text;
        headRow.append(cell);
      });
      const body = document.createElement('tbody');
      labels.forEach(label => {
        const row = body.insertRow();
        const title = document.createElement('th');
        title.scope = 'row';
        title.textContent = label;
        row.append(title);
        values.forEach(value => { row.insertCell().textContent = value.get(label) || ''; });
      });
      const caption = table.caption?.cloneNode(true);
      table.replaceChildren(...(caption ? [caption, head, body] : [head, body]));
      table.dataset.siennaHorizontal = 'true';
      const scroll = document.createElement('div');
      scroll.className = 'sienna-size-scroll';
      scroll.tabIndex = 0;
      table.before(scroll);
      scroll.append(table);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => format(), { once: true });
  else format();
  document.addEventListener('shopify:section:load', event => format(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
